import { useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../Asset/GameshubLogo.PNG";

const Header = ({
  cartCount,
  onCartClick,
  searchTerm,
  setSearchTerm,
  currentPage,
  setCurrentPage,
  isLoggedIn,
  logout,
}) => {
  const navigate = useNavigate();
  const userId = localStorage.getItem("userId");
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header className="sticky top-0 z-50 bg-white shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center space-x-6">
            <button
              onClick={() => {
                window.scrollTo(0, 0);
                navigate("/");
                setIsMobileMenuOpen(false);
              }}
              className="flex items-center hover:opacity-80 transition duration-200"
            >
              <img
                src={logo}
                alt={"GamesHub Logo"}
                className="h-16 object-cover mr-4"
              />
            </button>
            {/* Desktop Navigation */}
            <nav className="hidden md:flex space-x-1">
              <button
                onClick={() => {
                  window.scrollTo(0, 0);
                  navigate("/");
                }}
                className={`px-4 py-2 rounded-lg transition duration-200 font-medium ${
                  currentPage === "home"
                    ? "bg-red-600 text-white shadow-sm"
                    : "text-gray-700 hover:bg-gray-50 hover:text-gray-900"
                }`}
              >
                Home
              </button>
              <button
                onClick={() => {
                  window.scrollTo(0, 0);
                  navigate("/products");
                }}
                className={`px-4 py-2 rounded-lg transition duration-200 font-medium ${
                  currentPage === "products"
                    ? "bg-red-600 text-white shadow-sm"
                    : "text-gray-700 hover:bg-gray-50 hover:text-gray-900"
                }`}
              >
                Products
              </button>
              <button
                onClick={() => {
                  window.scrollTo(0, 0);
                  navigate("/about");
                }}
                className={`px-4 py-2 rounded-lg transition duration-200 font-medium ${
                  currentPage === "about"
                    ? "bg-red-600 text-white shadow-sm"
                    : "text-gray-700 hover:bg-gray-50 hover:text-gray-900"
                }`}
              >
                About
              </button>
              <button
                onClick={() => {
                  window.scrollTo(0, 0);
                  navigate("/contact");
                }}
                className={`px-4 py-2 rounded-lg transition duration-200 font-medium ${
                  currentPage === "contact"
                    ? "bg-red-600 text-white shadow-sm"
                    : "text-gray-700 hover:bg-gray-50 hover:text-gray-900"
                }`}
              >
                Contact
              </button>
              {userId && (
                <button
                  onClick={logout}
                  className="px-4 py-2 rounded-lg transition duration-200 font-medium text-gray-700 hover:bg-gray-50 hover:text-gray-900"
                >
                  Logout
                </button>
              )}
              {cartCount > 0 && (
                <button
                  onClick={() => {
                    window.scrollTo(0, 0);
                    navigate("/checkout");
                  }}
                  className={`px-4 py-2 rounded-lg transition duration-200 font-medium ${
                    currentPage === "checkout"
                      ? "bg-red-600 text-white shadow-sm"
                      : "text-gray-700 hover:bg-gray-50 hover:text-gray-900"
                  }`}
                >
                  Checkout
                </button>
              )}
            </nav>
          </div>
          <div className="flex items-center space-x-4">
            {/* Desktop Search */}
            {currentPage === "home" && (
              <input
                type="text"
                placeholder="Search games..."
                className="hidden sm:block px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            )}
            <button
              onClick={onCartClick}
              className="relative p-2 text-gray-600 hover:text-gray-900"
              style={{ fontSize: "25px" }}
            >
              🛒
              {cartCount > 0 && (
                <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
                  {cartCount}
                </span>
              )}
            </button>
            {/* Mobile menu button */}
            <button
              onClick={toggleMobileMenu}
              className="md:hidden p-2 text-gray-600 hover:text-gray-900"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                {isMobileMenuOpen ? (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                ) : (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                )}
              </svg>
            </button>
          </div>
        </div>
        {/* Mobile Navigation Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden border-t border-gray-200 py-4">
            {/* Mobile Search */}
            {currentPage === "home" && (
              <div className="mb-4">
                <input
                  type="text"
                  placeholder="Search games..."
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            )}
            <nav className="flex flex-col space-y-2">
              <button
                onClick={() => {
                  window.scrollTo(0, 0);
                  navigate("/");
                  setIsMobileMenuOpen(false);
                }}
                className={`px-4 py-2 rounded-lg transition duration-200 font-medium text-left ${
                  currentPage === "home"
                    ? "bg-red-600 text-white shadow-sm"
                    : "text-gray-700 hover:bg-gray-50 hover:text-gray-900"
                }`}
              >
                Home
              </button>
              <button
                onClick={() => {
                  window.scrollTo(0, 0);
                  navigate("/products");
                  setIsMobileMenuOpen(false);
                }}
                className={`px-4 py-2 rounded-lg transition duration-200 font-medium text-left ${
                  currentPage === "products"
                    ? "bg-red-600 text-white shadow-sm"
                    : "text-gray-700 hover:bg-gray-50 hover:text-gray-900"
                }`}
              >
                Products
              </button>
              <button
                onClick={() => {
                  window.scrollTo(0, 0);
                  navigate("/about");
                  setIsMobileMenuOpen(false);
                }}
                className={`px-4 py-2 rounded-lg transition duration-200 font-medium text-left ${
                  currentPage === "about"
                    ? "bg-red-600 text-white shadow-sm"
                    : "text-gray-700 hover:bg-gray-50 hover:text-gray-900"
                }`}
              >
                About
              </button>
              <button
                onClick={() => {
                  window.scrollTo(0, 0);
                  navigate("/contact");
                  setIsMobileMenuOpen(false);
                }}
                className={`px-4 py-2 rounded-lg transition duration-200 font-medium text-left ${
                  currentPage === "contact"
                    ? "bg-red-600 text-white shadow-sm"
                    : "text-gray-700 hover:bg-gray-50 hover:text-gray-900"
                }`}
              >
                Contact
              </button>
              {userId && (
                <button
                  onClick={() => {
                    logout();
                    setIsMobileMenuOpen(false);
                  }}
                  className="px-4 py-2 rounded-lg transition duration-200 font-medium text-left text-gray-700 hover:bg-gray-50 hover:text-gray-900"
                >
                  Logout
                </button>
              )}
              {cartCount > 0 && (
                <button
                  onClick={() => {
                    window.scrollTo(0, 0);
                    navigate("/checkout");
                    setIsMobileMenuOpen(false);
                  }}
                  className={`px-4 py-2 rounded-lg transition duration-200 font-medium text-left ${
                    currentPage === "checkout"
                      ? "bg-red-600 text-white shadow-sm"
                      : "text-gray-700 hover:bg-gray-50 hover:text-gray-900"
                  }`}
                >
                  Checkout
                </button>
              )}
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
